import { NgModule } from '@angular/core';
import { DateConversionsService } from './date-conversions/date-conversions.service';
import { GlobalErrorHandler } from './error-handler/global-error-handler';

@NgModule({
  imports: [],
  providers: [DateConversionsService, GlobalErrorHandler],
  declarations: [],
  exports: []
})
export class SharedModule {}

export { DateConversionsService, GlobalErrorHandler };
